import React from 'react';
import PropTypes from 'prop-types';
import enhance from '../../../SeriesDetailNav/BodyStyleSection/enhance';
import styles from './styles.module.scss';
import ProgressBar from '../../../ProgressBar';

export const BodyStyleProgressRow = ({ name, totalUnits, totalSubmitted }) => (
  <div>
    <div className={styles.bodyStyleName}>
      {name} ({totalSubmitted}/{totalUnits})
    </div>
    <div className={styles.progressBar}>
      <ProgressBar
        submitted={totalSubmitted}
        quota={totalUnits}
        height="24px"
        emptyColor="#ffffff"
      />
    </div>
  </div>
);

BodyStyleProgressRow.propTypes = {
  name: PropTypes.string.isRequired,
  totalSubmitted: PropTypes.number.isRequired,
  totalUnits: PropTypes.number.isRequired,
};

export default enhance(BodyStyleProgressRow);
